import browser from 'browser-detect';

export const BrowserSupported = {
  browserChecked: false,
  browserSupported: true,
  supportedBrowserVersions: {
    android: 81,
    chrome: 80,
    edge: 18,
    firefox: 68,
    ios: 12,
    opera: 67,
    safari: 13,
  },

  detectBrowser() {
    return browser();
  },

  supported() {
    if (this.browserChecked) {
      return this.browserSupported;
    }
    this.browserChecked = true;
    this.browserSupported = this.checkSupported();

    return this.browserSupported;
  },

  checkSupported() {
    try {
      const browserInfo = this.detectBrowser();
      const browserName = browserInfo.name.toLowerCase();
      const browserMajorVersion = Math.floor(browserInfo.versionNumber); // Truncate 12.345 to 12

      return this.supportedBrowser(browserName) && this.supportedBrowserVersion(browserName, browserMajorVersion);
    } catch (_error) {
      return false; // Default to unsupported on error
    }
  },

  supportedBrowser(name) {
    return this.supportedBrowserVersions[name] !== undefined;
  },

  supportedBrowserVersion(name, version) {
    const requiredMajorVersion = this.supportedBrowserVersions[name];

    return version >= requiredMajorVersion;
  },

  isSafari() {
    const browserInfo = this.detectBrowser();
    if (!browserInfo) return false;

    return browserInfo.name.toLowerCase() === 'safari';
  }
};
